<template>
  <el-row>
    <el-col :span="24">
      <el-card class="data">
        <div class="data-title flex-space-between" slot="header">
          <p>Bands</p>
          <div class="float-right">
            <Filters/>
          </div>
        </div>
        <div class="bands-box">
          <div v-for="(country, i) in data"
               :key="country.iso" class="bands-div">
            <div>
              <!--<p>{{ country.country }}</p>
              <el-radio-group v-model="country.name" @change="getValue(country.iso,country.name)">
                <el-radio-button label="A"></el-radio-button>
                <el-radio-button label="B"></el-radio-button>
              </el-radio-group>-->
              <p>{{ country.country }}</p>
              <el-select v-model="country.name" placeholder="Select" @change="getValue(country.iso,country.name)">
                <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import Filters from '../components/bands/Filters'
import { mapState, mapActions } from 'vuex'

export default {
  components: {
    Filters
  },
  data() {
    return {
      options: [{
        value: 'x',
        label: 'None'
      }, {
        value: 'A',
        label: 'A'
      }, {
        value: 'B',
        label: 'B'
      }],
    }
  },

  computed: {
    ...mapState('bands', ['loading', 'data']),
  },

  methods: {
    ...mapActions('bands', ['read', 'update']),
    getValue(iso,band){
      let bands = {
        iso: iso,
        band: band
      }
      this.update(bands)
    }
  },

  created() {
    this.read()
  }
}
</script>

<style lang="scss" scoped>
.bands-box{
  display: flex;
  flex-wrap: wrap;
}
.bands-div {
  width: 150px;
  margin-right: 10px;
  p{
    height: 45px;
  }
}
</style>
